import React from "react";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import Slideshow from "./Utils/SlideShow";
import AboutCard from "./Cards/AboutCard";
import Stack from "@mui/joy/Stack";
import PeopleIcon from "@mui/icons-material/People";
import SchoolIcon from "@mui/icons-material/School";
import BugReportIcon from "@mui/icons-material/BugReport";
import FlagIcon from "@mui/icons-material/Flag";
import Typography from "@mui/joy/Typography";

export default function AboutUs() {
  const year = new Date().getFullYear();
  const gradientStyle = {
    background:
      "linear-gradient(to right top, #7b12b2, #8411b8, #8e0fbf, #970cc5, #a107cb, #8148e4, #5767f6, #007eff, #00a5ff, #00c6ff, #00e2ff, #5ffbf1)",
    WebkitTextFillColor: "transparent",
    WebkitBackgroundClip: "text",
  };
  return (
    <div className="bg-background text-foreground  p-4 lg:p-8">
      <section className="text-center mb-16">
        <h1 className="text-4xl font-bold mb-4">
          Revolutionizing{" "}
          <span style={gradientStyle}>Cyber Security Education</span>, one
          challenge at a time.
        </h1>
        <div className="flex flex-col justify-center my-20 items-center mx-4 xl:mx-40 overflow-hidden">
          <Slideshow />
        </div>
      </section>

      <section className="bg-card  rounded-lg mb-16  md:mx-0 lg:mx-40  sm:mx-0">
        <div className="flex flex-col items-center mb-16 justify-center">
          <h2 className="text-3xl font-bold text-center">Our Mission</h2>
          <Typography
            level="body-lg"
            sx={{ textAlign: "center", width: "80%" }}
            className=" mt-6"
          >
            At {process.env.REACT_APP_NAME}, our mission is to create a dynamic,
            engaging, and educational environment. We provide a platform where
            users can enhance their cybersecurity skills, collaborate with a
            community of like-minded individuals, and contribute to global
            cybersecurity through CTF challenges and bug bounty programs.
          </Typography>
        </div>

        <Stack>
          <h2 className="text-3xl font-bold text-center">What We Offer</h2>
          <div className="my-10 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-2">
            <AboutCard
              icon={FlagIcon}
              title="CTF Challenges"
              content="Participate in exciting CTF challenges designed to test your skills and knowledge in cybersecurity. Compete with others, solve puzzles, and climb the leaderboard!"
              shareButtonText="Share"
              skipButtonText="Skip"
              iconColor="pink"
            />
            <AboutCard
              icon={BugReportIcon}
              title="Bug Bounty Programs"
              content="Join our Bug Bounty programs and help us identify and fix security vulnerabilities. Earn rewards and recognition for your contributions to making our platform safer."
              shareButtonText="Share"
              skipButtonText="Skip"
              iconColor="lightblue"
            />
            <AboutCard
              icon={SchoolIcon}
              title="Educational Resources"
              content="Access a wide range of educational resources to enhance your cybersecurity knowledge. From beginner tutorials to advanced courses, we've got you covered."
              shareButtonText="Share"
              skipButtonText="Skip"
              iconColor="#FFBF00"
            />
            <AboutCard
              icon={PeopleIcon}
              title="Community Engagement"
              content="Get involved in our vibrant community! Connect with other ardent cybersecurity enthusiasts, share knowledge, participate in discussions, and collaborate on projects."
              shareButtonText="Share"
              skipButtonText="Skip"
              iconColor="lightgreen"
            />
          </div>
        </Stack>
      </section>

      <section className="text-center mb-16 mx-4 lg:mx-40">
        <h2 className="text-3xl font-bold mb-8">Meet the Team</h2>
        <div className="flex flex-wrap ">
          <div className="w-full md:w-6/12 lg:w-3/12 mb-6 px-6 sm:px-6 lg:px-4">
            <div className="flex flex-col">
              <a href="#" className="mx-auto">
                <img
                  className="rounded-2xl drop-shadow-md hover:drop-shadow-xl transition-all duration-200 delay-100"
                  src="/assets/YashNagare.jpg"
                  style={{ height: "300px" }}
                />
              </a>
              <div className="text-center mt-6">
                <h1 className="  text-xl font-bold mb-1">Yash Nagare</h1>
                <div className="  font-light mb-2">Team Lead</div>
                <div
                  className="flex items-center justify-center opacity-50 hover:opacity-100
                                transition-opacity duration-300"
                >
                  <a
                    href="https://www.linkedin.com/in/NagareYash"
                    className="flex rounded-full hover:bg-blue-50 h-10 w-10"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LinkedInIcon
                      className="mdi mdi-twitter   mx-auto mt-2"
                      sx={{ color: "blue" }}
                    />
                  </a>
                  <a
                    href="https://github.com/NagareYash"
                    className="flex rounded-full hover:bg-blue-50 h-10 w-10"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <GitHubIcon className="mdi mdi-linkedin mx-auto mt-2" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full md:w-6/12 lg:w-3/12 mb-6 px-6 sm:px-6 lg:px-4">
            <div className="flex flex-col">
              <a href="#" className="mx-auto">
                <img
                  className="rounded-2xl drop-shadow-md hover:drop-shadow-xl transition-all duration-200 delay-100"
                  src="/assets/dev-img.png"
                  style={{ height: "300px" }}
                />
              </a>
              <div className="text-center mt-6">
                <h1 className="  text-xl font-bold mb-1">Devendra Mishra</h1>
                <div className="  font-light mb-2">Software Developer</div>
                <div
                  className="flex items-center justify-center opacity-50 hover:opacity-100
                                transition-opacity duration-300"
                >
                  <a
                    href="https://www.linkedin.com/in/devs-den/"
                    className="flex rounded-full hover:bg-blue-50 h-10 w-10"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LinkedInIcon
                      className="mdi mdi-twitter   mx-auto mt-2"
                      sx={{ color: "blue" }}
                    />
                  </a>
                  <a
                    href="https://github.com/Trex-Hub"
                    className="flex rounded-full hover:bg-blue-50 h-10 w-10"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <GitHubIcon className="mdi mdi-linkedin mx-auto mt-2" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full md:w-6/12 lg:w-3/12 mb-6 px-6 sm:px-6 lg:px-4">
            <div className="flex flex-col">
              <a href="#" className="mx-auto">
                <img
                  className="rounded-2xl drop-shadow-md hover:drop-shadow-xl transition-all duration-200 delay-100"
                  src="/assets/JohnDere.png"
                  style={{ height: "300px" }}
                />
              </a>
              <div className="text-center mt-6">
                <h1 className="  text-xl font-bold mb-1">Jasjoy Singh Saini</h1>
                <div className="  font-light mb-2">Software Developer</div>
                <div
                  className="flex items-center justify-center opacity-50 hover:opacity-100
                                transition-opacity duration-300"
                >
                  <a
                    href="https://www.linkedin.com/in/jasjyotsaini/"
                    className="flex rounded-full hover:bg-blue-50 h-10 w-10"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LinkedInIcon
                      className="mdi mdi-twitter   mx-auto mt-2"
                      sx={{ color: "blue" }}
                    />
                  </a>
                  <a
                    href="https://github.com/jas-jpg"
                    className="flex rounded-full hover:bg-blue-50 h-10 w-10"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <GitHubIcon className="mdi mdi-linkedin mx-auto mt-2" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full md:w-6/12 lg:w-3/12 mb-6 px-6 sm:px-6 lg:px-4">
            <div className="flex flex-col">
              <a href="#" className="mx-auto">
                <img
                  className="rounded-2xl drop-shadow-md hover:drop-shadow-xl transition-all duration-200 delay-100"
                  src="/assets/Gayatri.jpg"
                  style={{ height: "300px" }}
                />
              </a>
              <div className="text-center mt-6">
                <h1 className="  text-xl font-bold mb-1">Gayatri Tawade</h1>
                <div className="  font-light mb-2">UI/UX Lead</div>
                <div
                  className="flex items-center justify-center opacity-50 hover:opacity-100
                                transition-opacity duration-300"
                >
                  <a
                    href="https://www.linkedin.com/in/gayatript09"
                    className="flex rounded-full hover:bg-blue-50 h-10 w-10"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LinkedInIcon
                      className="mdi mdi-twitter   mx-auto mt-2"
                      sx={{ color: "blue" }}
                    />
                  </a>
                  <a
                    href="https://github.com/Gngt432"
                    className="flex rounded-full hover:bg-blue-50 h-10 w-10"
                  >
                    <GitHubIcon className="mdi mdi-linkedin mx-auto mt-2" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="text-center mb-16  xl:mx-40">
        <h2 className="text-3xl font-bold mb-8">We are Here</h2>
        <div className="flex flex-col items-center">
          <div>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d120775.03332926666!2d72.68076749726559!3d18.921663100000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7d1c06fffffff%3A0xc0290485a4d73f57!2sThe%20Taj%20Mahal%20Palace%2C%20Mumbai!5e0!3m2!1sen!2sin!4v1728139126444!5m2!1sen!2sin"
              width="600"
              height="450"
              style={{ border: "0", borderRadius: "1rem", margin: "0 auto" }}
              loading="lazy"
            ></iframe>
          </div>
          <div className="flex flex-col justify-center ml-5">
            <div className="flex items-center mt-8">
              <Typography sx={{ fontSize: "1.1rem" }} className="text-start">
                <LocationOnIcon
                  className="mr-4"
                  fontSize="large"
                  color="warning"
                  sx={{
                    fontSize: "25px",
                  }}
                />
                The Taj Mahal Palace, Mumbai
              </Typography>
            </div>
            <div className="flex items-center  mt-4 ">
              <Typography sx={{ fontSize: "1.1rem" }}>
                <EmailIcon
                  className="mr-4"
                  fontSize="large"
                  style={{ color: "lightblue", fontSize: "25px" }}
                />
                support@hacktheway.com
              </Typography>
            </div>
          </div>
        </div>
      </section>

      <footer className="bg-card p-8 rounded-lg">
        <p className="text-muted-foreground text-center">
          © HackTheWay {new Date().getFullYear()}, All rights reserved • Privacy
          Policy
        </p>
      </footer>
    </div>
  );
}
